/* This file is autogenerated, see readme.md for instructions */
import OfflineSvgIcon from '@bloomreach/banana-theme/icons/offline.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const OfflineIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <OfflineSvgIcon />
    </Icon>
  );
});

OfflineIcon.displayName = 'OfflineIcon';

export default OfflineIcon;
